import type { WorkOrderAssignment } from "../queries/useWorkOrderAssignmentMutations";

/**
 * Encodes a Work Order assignment row as the `user:<id>` / `team:<id>` token
 * the assignment MultiSelect controls share (WorkOrderSplitView.tsx,
 * ApproveWorkOrderForm.tsx).
 */
export function assigneeValue(assignment: WorkOrderAssignment): string {
  return assignment.kind === "user"
    ? `user:${assignment.userId}`
    : `team:${assignment.teamId}`;
}

/**
 * Decodes a `user:<id>` / `team:<id>` MultiSelect token back into the target
 * it represents.
 */
export function parseAssigneeValue(
  value: string,
): { userId: number } | { teamId: number } {
  const [kind, id] = value.split(":");
  return kind === "user" ? { userId: Number(id) } : { teamId: Number(id) };
}

/**
 * Whether the next set of assignee tokens differs from the saved assignments,
 * ignoring order.
 */
export function assigneesChanged(
  assignments: WorkOrderAssignment[],
  next: string[],
): boolean {
  const saved = assignments.map(assigneeValue);
  return (
    saved.length !== next.length || next.some((token) => !saved.includes(token))
  );
}
